import {FC} from "react";
import classNames from "classnames/dedupe";
import {cn} from "src/helpers/bem";
import "./styles.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const b = cn("confirm-dialog");

interface Props {
  className?: string;
  open: boolean;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: "primary" | "error";
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmDialog: FC<Props> = (props) => {
  const {
    className,
    open,
    title,
    description,
    confirmText = "Подтвердить",
    cancelText = "Отмена",
    confirmColor = "primary",
    loading = false,
    onConfirm,
    onClose,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      className={classNames(b(), className)}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={b("content")}>
        {description && <DialogContentText>{description}</DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={loading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
